export default "__VITE_PUBLIC_ASSET__b8fb2b15__"